import script from "./CircleTag.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleTag.vue?vue&type=script&setup=true&lang=js"

import "./CircleTag.vue?vue&type=style&index=0&id=07a5bc5b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a5bc5b"]])

export default __exports__